module.exports = __webpack_public_path__ + "static/bigman-d8238b7c69ea254fb96a6f68c6ce0b6a.jpg";